import $ from 'jquery'

function userSessionsNew($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $signInForm,
      $emailField,
      $tierThreeForm;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $signInForm = $('#new_user_session', $mainContainer);
    $tierThreeForm = $('.sign-in-tier-three-form', $mainContainer);
    $emailField = $('#user_session_email', $signInForm);

    bindDomEvents();
  }

  function bindDomEvents() {
    $('#user_session_email', $signInForm).trigger('focus');

    $signInForm.formMaterialDesign();
    $tierThreeForm.formMaterialDesign();
    $signInForm.on('submit', function() {
      var valid = false;
      if (checkRequiredFields()) {
        valid = true;

        SOPHIA.formGA($signInForm, 'form_submit');
      }

      return valid;
    });
  }

  function checkRequiredFields() {
    var valid = true,
        emailErrorSpan = $('#email-error', $signInForm),
        passwordErrorSpan = $('#password-error', $signInForm);

    if (0 == $emailField.val().length) {
      valid = false;
      emailErrorSpan.prev().addClass('field_with_errors');
      emailErrorSpan.text('Login cannot be blank.');
    } else {
      emailErrorSpan.text('');
      emailErrorSpan.prev().removeClass('field_with_errors');
    }

    if (0 == $('#user_session_password', $signInForm).val().length) {
      valid = false;
      passwordErrorSpan.prev().addClass('field_with_errors');
      passwordErrorSpan.text('Password cannot be blank.');
    } else {
      passwordErrorSpan.text('');
      passwordErrorSpan.prev().removeClass('field_with_errors');
    }

    return valid;
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
  };
}

// jQuery plugin method
$.fn.userSessionsNew = function(options) {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('userSessionsNew')) {
      $this.data('userSessionsNew', userSessionsNew($this, options));
    }
  });
};
